import React from "react";

import {
  IStaticElementUnion,
  StaticElementState,
  StaticTypes,
  isDescriptionElement,
} from "@graffer-inc/form-schema";
import { DescriptionElementEditor } from "./description-element-editor";

type Props = {
  element: IStaticElementUnion;
  onElementUpdate: (v: IStaticElementUnion) => void;
};

export const StaticElementEditor: React.FC<Props> = ({
  element,
  onElementUpdate,
}) => {
  return (
    <>
      {new StaticElementState(element.staticType).matchType({
        [StaticTypes.Description]: isDescriptionElement(element) ? (
          <DescriptionElementEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ) : null,
        [StaticTypes.Image]: null, // TODO: (yamada)画像項目の画像を製品側で管理する実装が整い次第、実装する
      })}
    </>
  );
};
